import { generateList } from "./generateList";
export const formatAddress = ({ address, format, debug }) => {
    let list;
    switch (format) {
        case "with-postalCode":
            list = generateList([
                {
                    value: address.fullStreetAddress
                        ? address.fullStreetAddress
                        : address.addressLine1
                            ? address.addressLine1
                            : address.fullAddress
                                ? address.fullAddress
                                : null,
                    label: "",
                },
                {
                    value: address.city ? address.city : null,
                    label: "",
                },
                {
                    value: generateList([
                        {
                            value: address.state ? address.state : null,
                            label: "",
                        },
                        {
                            value: address.postalCode ? address.postalCode : null,
                            label: "",
                        },
                    ], ", "),
                    label: "",
                },
            ], " ");
            break;
        default:
            list = generateList([
                {
                    value: address.fullStreetAddress
                        ? address.fullStreetAddress
                        : address.addressLine1
                            ? address.addressLine1
                            : address.fullAddress
                                ? address.fullAddress
                                : null,
                    label: " ",
                },
                {
                    value: address.city ? address.city : null,
                    label: "",
                },
                {
                    value: generateList([
                        {
                            value: address.state ? address.state : null,
                            label: "",
                        },
                        {
                            value: address.zip ? address.zip : null,
                            label: "",
                        },
                    ], ", "),
                    label: "",
                },
            ], " ");
            break;
    }
    if (debug) {
        console.log("formatAddressDebug: ", { input: address, output: list });
    }
    return list;
};
